// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d9897e90","567":"3767a28c","703":"aaf84026","787":"7ebfebda","933":"9175c1ff"}[chunkId] + ".chunk.js";
};